var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _vm.restListLarge.addressEntered
        ? _c("section-heading", [
            _vm._v(_vm._s(_vm.addressEnteredRestListTitle)),
          ])
        : _c("section-heading", [_vm._v(_vm._s(_vm.restListTitle))]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "large-card-list" },
        [
          _vm._l(_vm.filterableRestList, function (rest) {
            return _c(
              "li",
              { key: rest.id, staticClass: "large-card-list-item" },
              [
                _c("card-large", {
                  attrs: {
                    restId: rest.id,
                    name: rest.name,
                    waitTime: rest.waitTime,
                    openTime: rest.openTime,
                    open: rest.open === 1,
                    acceptsDelivery: rest.acceptsDelivery,
                    acceptsPickup: rest.acceptsPickup,
                    categories: rest.categories,
                    image: rest.image,
                    url: rest.url,
                    hours: rest.hours,
                    deliveryFee: rest.fee,
                    distance: rest.distance,
                  },
                  on: { showLaterOrderModal: _vm.showLaterOrderModal },
                }),
              ],
              1
            )
          }),
          _vm._v(" "),
          _vm.filterableRestList.length === 0
            ? _c("li", [
                _c("p", { staticClass: "no-results" }, [
                  _vm._v(
                    "\n        Sorry, no results matching that name/category...\n      "
                  ),
                ]),
              ])
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.showLaterOrder
        ? _c(
            "modal",
            { on: { hideModal: _vm.hideLaterOrderModal } },
            [
              _c("later-order-same-hours", {
                attrs: {
                  restId: _vm.restId,
                  hours: _vm.hours,
                  restName: _vm.restName,
                },
                on: {
                  goToMenu: function ($event) {
                    _vm.hideLaterOrderModal()
                    _vm.goToMenu()
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }